module.exports = __webpack_public_path__ + "img/portrait-088.def1114b.jpg";